import { type Editor } from '@tiptap/react'
import { Card } from '#app/components/ui/card.js'
import { Textarea } from '#app/components/ui/textarea.js'
import { GlobalInputSettings } from '../components'

export const DropdownSettings = ({
	pos,
	node,
	editor,
}: {
	pos: number
	node: any
	editor: Editor
}) => {
	const options = node.attrs.options.replaceAll(',', '\n')

	return (
		<div className="flex flex-col gap-2">
			<GlobalInputSettings
				node={node}
				setRequired={(e: any) => {
					editor
						.chain()
						.setNodeSelection(pos)
						.setDropdownInputRequired(String(e) === 'true')
						.run()
				}}
				setConnect={(value: string) => {
					editor.chain().setNodeSelection(pos).setDropdownInputTo(value).run()
				}}
			/>
			<Card variant="filled" className="flex-col gap-1" size="sm">
				<p className="font-medium">Options</p>
				<p className="text-sm text-muted-foreground">One option per line</p>
				<Textarea
					placeholder="One option per line"
					defaultValue={options}
					onChange={e => {
						if (e.currentTarget.value) {
							editor
								.chain()
								.setNodeSelection(pos)
								.setDropdownInputOptions(
									e.currentTarget.value.replaceAll('\n', ','),
								)
								.run()
						}
					}}
				/>
			</Card>
		</div>
	)
}

export default DropdownSettings
